import { I18n } from 'common'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import { Vehicle } from 'src/store/models/Vehicles'
import { defaultTheme } from 'src/theme'
import { Price } from 'src/ui-components'
import { RootState } from 'store'
import styled from 'styled-components'
import {
  getAllValidParts,
  getSellerItemsCost,
  getSellerPartsCoreCost,
  getSellerPartsBundleSavings,
} from '../store/cartSelectors'
import { SellerWithLocations } from '../store/ISellerCart'

interface SellerPriceDetailsProps {
  sellerWithLocations: SellerWithLocations
  vehicle: Vehicle
}

export const SellerPriceDetails = observer(
  ({ sellerWithLocations, vehicle }: SellerPriceDetailsProps): ReactElement => {
    const itemsCost = useSelector((state: RootState) =>
      getSellerItemsCost(state, vehicle, sellerWithLocations)
    )
    const coreCost = useSelector((state: RootState) =>
      getSellerPartsCoreCost(
        getAllValidParts(state, vehicle, sellerWithLocations.coverageKey)
      )
    )
    const bundleSavings = useSelector((state: RootState) =>
      getSellerPartsBundleSavings(
        getAllValidParts(state, vehicle, sellerWithLocations.coverageKey)
      )
    )
    const orderTotal = itemsCost + coreCost - bundleSavings
    return (
      <Container>
        <SellerTitle>{sellerWithLocations.sellerName}</SellerTitle>
        <CostDetailsWrapper>
          <span>
            <I18n name="items" />
            {`:`}
          </span>
          <Price num={itemsCost} />
        </CostDetailsWrapper>
        {coreCost > 0 && (
          <CostDetailsWrapper>
            <span>
              <I18n name="coreCost" />
              {`:`}
            </span>
            <Price num={coreCost} />
          </CostDetailsWrapper>
        )}
        {bundleSavings > 0 && (
          <CostDetailsWrapper style={{ color: defaultTheme.colors.greyDark }}>
            <I18n name="bundleSavings" />
            <span>
              {`-`}
              <Price num={bundleSavings} />
            </span>
          </CostDetailsWrapper>
        )}
        <CostDetailsWrapper style={{ marginBottom: '15px' }}>
          <span>
            <I18n name="orderTotal" />
            {`:`}
          </span>
          <Price num={orderTotal} />
        </CostDetailsWrapper>
      </Container>
    )
  }
)

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 36px;
`

const SellerTitle = styled.h4`
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: ${defaultTheme.colors.text};
  mix-blend-mode: normal;
  text-align: left;
`
const CostDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  justify-content: space-between;
`
